// extracted by mini-css-extract-plugin
export default {"container":"TextInput_container__v3Vwk","text":"TextInput_text__Nld20","input":"TextInput_input__YOUtH"};